import { Navigate, useLocation } from 'react-router-dom';
import React, { ReactNode } from 'react';
import { useAuth } from '../context/Auth';

export const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
